export enum CommentsAccessLevelEnum {
  ALL_USERS = 0,
  ADMINS_ONLY = 1,
  SYSTEM_MESSAGES = 2,
}
